import { render, staticRenderFns } from "./NaoAppFlex.vue?vue&type=template&id=0bb9175f&scoped=true"
import script from "./NaoAppFlex.vue?vue&type=script&lang=js"
export * from "./NaoAppFlex.vue?vue&type=script&lang=js"
import style0 from "./NaoAppFlex.vue?vue&type=style&index=0&id=0bb9175f&prod&scoped=true&lang=css"
import style1 from "./NaoAppFlex.vue?vue&type=style&index=1&id=0bb9175f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb9175f",
  null
  
)

export default component.exports